import Vue from 'vue';
import $ from 'jquery';
import _ from 'lodash';
import 'bootstrap/js/tooltip';
import 'bootstrap/js/popover';
import 'flatpickr/dist/flatpickr.css'; // eslint-disable-line import/no-extraneous-dependencies
import flatPickr from 'vue-flatpickr-component';
import { Slovenian } from 'flatpickr/dist/l10n/sl'; // eslint-disable-line import/no-extraneous-dependencies
import SubcatSelect from './widgets/SubcatSelect.vue';

const app = new Vue({
  el: '#app',
  data: {
    flatPickrDate: {
      dateFormat: 'j. n. Y',
      locale: Slovenian,
    },
    flatPickrDateTime: {
      dateFormat: 'j. n. Y H:i',
      enableTime: true,
      time_24hr: true,
      locale: Slovenian,
    },
  },
  methods: {
    loadTreeselectOptions(id) {
      return (callback) => {
        $.getJSON(`/e-pravnik/get_sifrant_for_treeselect/${id}/`).done((data) => {
          callback(null, data.data);
        });
      };
    },
  },
  components: {
    flatPickr,
    SubcatSelect,
  },
});

window.app = app;

$('body').popover({
  container: 'body',
  selector: '[data-toggle="popover"]',
});

$('body').on('click', '[data-toggle=popover]', function onClick() {
  $('[data-toggle=popover]').not(this).popover('hide');
});

function showFieldError(container, errorText) {
  const oldHtml = container[0].outerHTML.replace(/(\s|\n)*/g, '');

  const errorHtml = `
    <p class="help-block"><small>
      ${errorText}
    </small></p>
  `;

  container.addClass('has-error has-field-error');
  if (container.find('.help-block').length) {
    container.find('.help-block').replaceWith(errorHtml);
  } else if (container.find('.help-block-text').length) {
    container.find('.help-block-text').before(errorHtml);
  } else {
    container.append(errorHtml);
  }

  const newHtml = container[0].outerHTML.replace(/(\s|\n)*/g, '');
  return oldHtml !== newHtml;
}

function stopAndShowError(event, container, errorText, scroll) {
  const prevent = showFieldError(container, errorText);
  if (event && prevent) {
    event.preventDefault();
    if (scroll) {
      try {
        container[0].scrollIntoView();
      } catch (error) {
        $(window).scrollTop(0);
      }
    }
  }
}

$('.report-message-text a').on('click', () => {
  $('#report-message-container').show();
});

$('#report-message-form').on('submit', function onReportSubmit(event) {
  event.preventDefault();
  const $form = $(this);
  const data = $form.serialize();
  $form.find('button').attr('disabled', 'disabled');
  $form.find('textarea').attr('disabled', 'disabled');
  $.ajax({
    type: 'POST',
    url: $form.attr('action'),
    data,
    success() {
      $('#report-message-container').hide();
      $('.report-message-text').text('Hvala za sporočilo!');
    },
    error() {
      $('#report-message-container').hide();
      $('.report-message-text').text('Napaka pri pošiljanju!');
    },
  });
});

$('form#epravnik-wizard').on('click', function onClick(event) {
  if (event.target && event.target.tagName === 'BUTTON') {
    this.submitButtonValue = event.target.value;
    if (this.submitButtonValue === 'prev') {
      const $form = $(this);
      if ($form.data('any-required')) {
        $form.find(':input[required]').removeAttr('required');
      }
    }
  }
});

function checkFormErrors($form, event) {
  if ($form.data('any-required')) {
    return;
  }

  let scroll = true;
  const $controls = $form.find('.control-input:not(.submit-buttons)');
  $controls.each(function checkAnswer() {
    const $this = $(this);
    if ($this.is('[data-number-of-answers]')) {
      const expected = $this.data('number-of-answers');
      const checked = $this.find('input[type="checkbox"]:checked');
      // eslint-disable-next-line eqeqeq
      if (checked.length != expected) {
        stopAndShowError(event, $this, `Izberite število opcij: ${expected}.`, scroll);
        scroll = false;
      }
    } else if ($this.is('[data-is-number]')) {
      const input = $this.find('input');
      let value = input.val();
      if (value == null || value.trim() === '') {
        stopAndShowError(event, $this, 'Izpolnite polje.', scroll);
        scroll = false;
      } else if (/^[\d,.]*$/.test(value)) {
        value = value.trim();
        const lastComma = value.lastIndexOf(',');
        const lastPeriod = value.lastIndexOf('.');
        if (lastComma !== -1 && lastPeriod !== -1) {
          if (lastComma > lastPeriod) {
            value = value.replace(/\./g, '');
          } else {
            value = value.replace(/,/g, '').replace('.', ',');
          }
        } else if (lastComma !== -1 && value.split(',').length > 2) {
          value = value.replace(/,(?=\d{3}(?:,|$))/g, '');
        } else if (lastPeriod !== -1) {
          value = value.replace(/\.(?=\d{3}(?:\.|$))/g, '').replace('.', ',');
        }
        input.val(value);
      } else {
        stopAndShowError(event, $this, 'Vnesite veljavno vrednost.', scroll);
        scroll = false;
      }
    } else if ($this.is('[data-is-regex]')) {
      const $input = $this.find(':input');
      const val = $input.val();
      const regex = new RegExp($this.data('is-regex'));
      if (val == null || val.trim() === '') {
        stopAndShowError(event, $this, 'Izpolnite polje.', scroll);
        scroll = false;
      } else if (!regex.test(val)) {
        stopAndShowError(event, $this, 'Vnesite veljavno vrednost.', scroll);
        scroll = false;
      }
    } else {
      const $inputs = $this.find(':input');
      if ($inputs.is('input[type="radio"]') && $inputs.filter(':checked').length < 1) {
        stopAndShowError(event, $this, 'Izberite opcijo.', scroll);
        scroll = false;
      } else if ($inputs.length === 1) {
        if ($inputs.is('select')) {
          const $selectedOption = $inputs.find(':selected');
          const val = $selectedOption.val();
          const text = $selectedOption.text();
          if (/^izberi(?:te)?\s/.test(text) || /ni\sizbran(?:a|o)?$/.test(val) || val == null || val.trim() === '' || text == null || text.trim() === '') {
            stopAndShowError(event, $this, 'Izberite veljavno vrednost.', scroll);
            scroll = false;
          }
        } else {
          const val = $inputs.val();
          if (val == null || val.trim() === '') {
            stopAndShowError(event, $this, 'Izpolnite polje.', scroll);
            scroll = false;
          }
        }
      }
    }
  });
  if (event && !event.isDefaultPrevented()) {
    $controls.each(function checkAnswer() {
      const $this = $(this);
      if ($this.is('.has-error[data-is-regex]')) {
        const $input = $this.find(':input');
        const val = $input.val();
        const regex = new RegExp($this.data('is-regex'));
        if (val && !regex.test(val)) {
          $input.val('');
        }
      } else if ($this.is('.has-error[data-is-number]')) {
        const $input = $this.find(':input');
        const val = $input.val();
        const regex = /^[\d,.]*$/;
        if (val && !regex.test(val)) {
          $input.val('');
        }
      }
    });
    const fieldLabelsWithErrors = _.uniq($controls
      .filter('.has-error')
      .find(':input')
      .map(function getName() {
        return $(this).attr('name');
      })
      .get());
    $('<input />').attr('type', 'hidden').attr('name', 'field-labels-with-errors')
      .val(JSON.stringify(fieldLabelsWithErrors))
      .appendTo($form);
  }
}

$('form#epravnik-wizard').on('submit', function onSubmit(event) {
  if (this.submitButtonValue !== 'next') {
    return;
  }

  const $form = $(this);
  checkFormErrors($form, event);
});

$(() => {
  const show = $('#show_errors_immediately').text();
  if (show === 'True') {
    const $form = $('form#epravnik-wizard');
    checkFormErrors($form);
  }
});



// WEBPACK FOOTER //
// ./src/epravnik/form.js